import { render, staticRenderFns } from "./CourseEdit.vue?vue&type=template&id=5030698a&scoped=true&"
import script from "./CourseEdit.vue?vue&type=script&lang=js&"
export * from "./CourseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5030698a",
  null
  
)

export default component.exports